import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import {Card, CardActions, Divider} from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import TagsReporte from "../components/TagsReporte";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Button from "@material-ui/core/Button";
import {reportesResources, tagResources} from "../endpoints";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import NumberFormat from "react-number-format";
import {Autocomplete} from "@material-ui/lab";
import CircularProgress from "@material-ui/core/CircularProgress";
import InputAdornment from '@material-ui/core/InputAdornment';
import SnackbarAlert from "../components/SnackbarAlert";
import DialogExportar from "../components/DialogExportar";
import useToken from "../useToken";
import { Redirect } from "react-router-dom";

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            isNumericString
            prefix=""
        />
    );
}

class Reportes extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            tag: '',
            tag_inicial: '',
            tag_final: '',
            seleccion:'por_zona',
            tipo:'',
            formato: 'desagrupado',
            datos:[],
            open: false,
            zonas:[],
            porcentaje_zona: '',
            open_importar_tag:false,
            file : "",
            progress: false,
            disabled: false,
            openSnack:false,
            message: '',
            severity:'',
            monto:'',
            operador: '',
            operadores: []
        }
    }

    handleChange = (event) => {
        this.setState({[event.target.name]: event.target.value.trim()});
    }

    eliminarTag = (rowData) =>{
        const array = [...this.state.datos]; // make a separate copy of the array
        const index = array.indexOf(rowData);
        if (index !== -1) {
            array.splice(index, 1);
            this.setState({datos: array});
        }
    }

    limpiarTags = () =>{
        this.setState({datos: []});
    }

    agregarTag = () => {
        if(this.state.tag !== ''){
            let tag = {
                tag: this.state.tag
            }
            if(!this.containsObject(tag,this.state.datos)){
                this.setState({datos : this.state.datos.concat(tag), tag:''})
            }
            else{
                this.setState({tag:''})
            }
        }
    }

    getEventType = (event) =>{
        if(event.keyCode === 13){
            this.agregarTag()
        }
    }

    containsObject = (obj, list) =>{
        for (let i = 0; i < list.length; i++) {
            if (list[i].tag === obj.tag) {
                return true;
            }
        }
        return false;
    }
    agregarRangoTag = () =>{
        let datos = []
        let inicial = parseInt(this.state.tag_inicial)
        let final = parseInt(this.state.tag_final)
        for (let i = inicial; i < final + 1; i++){
            let tag = {
                tag: i
            }
            if(!this.containsObject(tag,this.state.datos)){
                datos.push(tag)
            }
        }
        this.setState({datos: this.state.datos.concat(datos), tag_inicial:'', tag_final:''})
    }

    handleClose = () =>{
        this.setState({open:false, open_importar_tag:false})
    }

    componentDidMount() {
        const verifyFolio = useToken.verifyToken()
        if(!verifyFolio){
            this.props.history.push('/inventarios');
        }
        else{
            this.obtenerZonas()
            this.obtenerTipoCampos()
            this.obtener_operadores()
        }
    }

    obtenerZonas = () =>{
        reportesResources.getZonas().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then( data => {
            this.setState({zonas:data})
        }).catch(error=> {
            console.error(error);
        });
    }

    obtener_operadores = () =>{
        reportesResources.operadores_reportes().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then( data => {
            this.setState({operadores:data})
        }).catch(error=> {
            console.error(error);
        });
    }

    handleOnFileChange = (e) => {
        let file = e.target.files[0];
        this.setState({
            [e.target.id] : file
        })
    }

    submitForm = () => {
        this.setState({progress:true,disabled:true, open_alert:false})
        const archivo = this.state.file;
        const fileReader = new FileReader();
        fileReader.onload = () => {
            const contents = fileReader.result;
            const argumentos = contents.split(/\s+/);
            let datos = []
            for (let i = 0; i < argumentos.length; i++){
                if(argumentos[i]!== ''){
                    let tag = {
                        tag: argumentos[i]
                    }
                    if(!this.containsObject(tag,this.state.datos) && !this.containsObject(tag,datos)){
                        datos.push(tag)
                    }
                }
            }
            this.setState({
                datos: this.state.datos.concat(datos),
                progress:false,
                open_importar_tag:false,
                openSnack: true,
                message: "Tag/s importado/s de forma correcta",
                severity: "success",
                disabled:false})
        }
        fileReader.readAsText(archivo);
    }

    enviarDatosReportes = () => {
        const tags = this.state.datos
        const tipo = this.state.tipo
        const formato = this.state.formato
        let params = ""
        let reporte
        tags.forEach(element => {
            if (tags.indexOf(element) === 0) {
                params = params + element.tag
            } else {
                params = params + "," + element.tag
            }
        });
        if (tipo === "normal") {
            if (formato === "desagrupado") {
                reporte = "tag_detalle"
            } else if (formato === "agrupado") {
                reporte = "tag_agrupado"
            } else {
                reporte = "tag_consolidado"
            }
        } else {
            if (formato === "desagrupado") {
                reporte = "tag_detalle_factor"
            } else if (formato === "agrupado") {
                reporte = "tag_agrupado_factor"
            } else {
                reporte = "tag_consolidado"
            }
        }
        this.setState({open: true, reporte: reporte, params: params,openSnack:false})
    }

    obtenerTipoCampos = () =>{
        tagResources.obtenerTipoCampos().then(res => res.json())
            .then(
                (result) => {
                    if(result === "con_factor"){
                        this.setState({tipo: 'factor'})
                    }
                    else{
                        this.setState({tipo: 'normal'})
                    }
                },
                (error) => {
                    console.log(error)
                }
            )
    }

    agregarTagZonaPorcentaje = () =>{
        let ubicacion = this.state.zona.id
        let porcentaje = 0
        let monto = 0
        if(this.state.porcentaje_zona !== ""){
            porcentaje = this.state.porcentaje_zona
        }
        if(this.state.monto !== ""){
            monto = this.state.monto
        }
        reportesResources.getTagZonaPorcentaje(ubicacion,porcentaje,monto).then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then( data => {
            let datos = []
            for(let i = 0; i < data.length; i++ ){
                if(!this.containsObject(data[i],this.state.datos) && !this.containsObject(data[i],datos)){
                    datos.push(data[i])
                }
            }
            this.setState({datos: this.state.datos.concat(datos), monto: '', porcentaje_zona:''})
        }).catch(error=> {
            console.error(error);
        });
    }

    agregarTagOperador= () =>{
        reportesResources.tag_operador(this.state.operador).then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then( data => {
            let datos = []
            for(let i = 0; i < data.length; i++ ){
                if(!this.containsObject(data[i],this.state.datos) && !this.containsObject(data[i],datos)){
                    datos.push(data[i])
                }
            }
            this.setState({datos: this.state.datos.concat(datos), monto: '', porcentaje_zona:'', operador:''})
        }).catch(error=> {
            console.error(error);
        });
    }
    refrescar =(estado,severity) =>{
        this.setState({
            open: false,
            openSnack: true,
            message: estado,
            severity: severity})
    }

    render() {
        const verifyFolio = useToken.verifyToken()

        if(!verifyFolio){
            return <Redirect to="/inventarios"/>
        }
        else{
            return(
                <div>
                <Typography variant="h4" gutterBottom>
                    Reportes
                </Typography>

                    <Grid container spacing={2} direction={"row"}>
                        <Grid item md={6}>
                            <Card style={{width:'100%'}}>
                                <CardContent>
                                    <Grid container spacing={2} alignItems={"center"} justifyContent={"flex-start"}>
                                        <Grid item>
                                            <Typography variant={'h6'}>Tipo:</Typography>
                                        </Grid>
                                        <Grid item>
                                            <RadioGroup style={{ display: 'inline-block'}} aria-label="gender" name="tipo" value={this.state.tipo} onChange={this.handleChange}>
                                                <FormControlLabel value="normal" control={<Radio/>} label="Normal" />
                                                <FormControlLabel value="factor" control={<Radio/>} label="Por factor" />
                                            </RadioGroup>
                                        </Grid>
                                    </Grid>
                                    <Divider/>
                                    <Grid container spacing={2} alignItems={"center"} justifyContent={"flex-start"}>
                                        <Grid item>
                                            <Typography variant={'h6'}>Formato:</Typography>
                                        </Grid>
                                        <Grid item>
                                            <RadioGroup style={{ display: 'inline-block'}} aria-label="gender" name="formato" value={this.state.formato} onChange={this.handleChange}>
                                                <FormControlLabel value="agrupado" control={<Radio/>} label="Agrupado" />
                                                <FormControlLabel value="desagrupado" control={<Radio/>} label="Desagrupado" />
                                                <FormControlLabel value="consolidado" control={<Radio/>} label="Consolidado" />
                                            </RadioGroup>
                                        </Grid>
                                    </Grid>
                                    <Divider/>
                                    <Grid container spacing={2} alignItems={"center"} justifyContent={"flex-start"}>
                                        <Grid item>
                                            <Typography variant={'h6'}>Selección:</Typography>
                                        </Grid>
                                        <Grid item>
                                            <RadioGroup style={{ display: 'inline-block'}} aria-label="gender" name="seleccion" value={this.state.seleccion} onChange={this.handleChange}>
                                                <FormControlLabel value="por_zona" control={<Radio/>} label="Por zona" />
                                                <FormControlLabel value="personalizado" control={<Radio/>} label="Personalizado" />
                                                <FormControlLabel value="por_operador" control={<Radio/>} label="Por operador" />
                                            </RadioGroup>
                                        </Grid>
                                        <Grid item>
                                            <Button variant="contained" color="primary" onClick={()=>{this.setState({open_importar_tag:true})}}>
                                                Importar tag/s para imprimir
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                            <br/>
                            { this.state.seleccion === 'personalizado' &&
                            <Card style={{width:'100%'}}>
                                <Typography style={{marginLeft:'15px', marginTop:'16px'}} variant={'h6'}>Personalizado:</Typography>
                                <CardContent>
                                    <Grid container spacing={1} alignItems={"center"} justifyContent={"flex-start"}>
                                        <Grid item>
                                            <Typography variant={'subtitle1'}>Agregar un tag:</Typography>
                                        </Grid>
                                        <Grid item>
                                            <TextField value={this.state.tag}
                                                    name="tag"
                                                    variant="outlined"
                                                    margin={'dense'}
                                                    fullWidth
                                                    helperText="Ingrese el tag y presione enter para agregar"
                                                    onKeyDown={this.getEventType}
                                                    onChange={this.handleChange}/>
                                        </Grid>
                                    </Grid>
                                    <br/>
                                    <Divider/>
                                    <Grid container spacing={1} alignItems={"center"} justifyContent={"flex-start"}>
                                        <Grid item>
                                            <Typography variant={'subtitle1'}>Agregar rango de tag:</Typography>
                                        </Grid>
                                        <Grid item>
                                            <TextField value={this.state.tag_inicial}
                                                    name="tag_inicial"
                                                    fullWidth
                                                    label={"Tag inicial"}
                                                    variant="outlined"
                                                    margin={'dense'}
                                                    onChange={this.handleChange}
                                                    InputProps={{
                                                        inputComponent: NumberFormatCustom,
                                                    }}/>
                                        </Grid>
                                        <Grid item>
                                            <TextField value={this.state.tag_final}
                                                    name="tag_final"
                                                    variant="outlined"
                                                    margin={'dense'}
                                                    label={"Tag final"}
                                                    fullWidth
                                                    onChange={this.handleChange}
                                                    InputProps={{
                                                        inputComponent: NumberFormatCustom,
                                                    }}/>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                                <CardActions>

                                            <Button disabled={!this.state.tag_inicial || !this.state.tag_final} variant="contained" color={'primary'} onClick={this.agregarRangoTag}>Agregar</Button>

                                </CardActions>
                            </Card> }
                            {this.state.seleccion === 'por_zona' &&
                            <Card style={{width:'100%'}}>
                                <Typography style={{marginLeft:'15px', marginTop:'16px'}} variant={'h6'}>Por zona:</Typography>
                                <CardContent >
                                    <Grid container spacing={1} alignItems={"center"} justifyContent={"flex-start"}>
                                        <Grid item>
                                            <Typography variant={'subtitle1'}>Mayor valor:</Typography>
                                        </Grid>
                                        <Grid item>
                                            <TextField value={this.state.porcentaje_zona}
                                                    name="porcentaje_zona"
                                                    variant="outlined"
                                                    label="Porcentaje"
                                                    margin={'dense'}
                                                    onChange={this.handleChange}
                                                    InputProps={{
                                                        inputComponent: NumberFormatCustom,
                                                        endAdornment:<InputAdornment position="end">%</InputAdornment>
                                                    }}/>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant={'subtitle1'}>Monto mayor igual:</Typography>
                                        </Grid>
                                        <Grid item>
                                            <TextField value={this.state.monto}
                                                    name="monto"
                                                    variant="outlined"
                                                    label="Monto"
                                                    margin={'dense'}
                                                    onChange={this.handleChange}
                                                    InputProps={{
                                                        inputComponent: NumberFormatCustom,
                                                        endAdornment:<InputAdornment position="end">$</InputAdornment>
                                                    }}/>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Autocomplete
                                                onChange={(event, newValue) => {
                                                    if(newValue === null) {
                                                        this.setState({zona: null})
                                                    }
                                                    else{
                                                        this.setState({zona: newValue})
                                                    }
                                                }}

                                                options={this.state.zonas}
                                                noOptionsText={"No hay opciones"}
                                                getOptionLabel={(option) => option.p || ""}
                                                renderInput={(params) => (
                                                    <TextField {...params} variant="standard" label="Zonas" placeholder="Disponibles" />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>
                                </CardContent>
                                <CardActions>
                                    <Button disabled={!this.state.zona} variant="contained" color={'primary'} onClick={this.agregarTagZonaPorcentaje}>Agregar</Button>
                                </CardActions>
                            </Card>}
                            {this.state.seleccion === 'por_operador' &&
                                <Card style={{width:'100%'}}>
                                    <Typography style={{marginLeft:'15px', marginTop:'16px'}} variant={'h6'}>Por operador:</Typography>
                                    <CardContent >
                                        <Grid container spacing={1} alignItems={"center"} justifyContent={"flex-start"}>
                                            <Grid item xs={12}>
                                                <Autocomplete
                                                    onChange={(event, newValue) => {
                                                        if(newValue === null) {
                                                            this.setState({operador: null})
                                                        }
                                                        else{
                                                            this.setState({operador: newValue.cod_operador})
                                                        }
                                                    }}

                                                    options={this.state.operadores}
                                                    noOptionsText={"No hay opciones"}
                                                    getOptionLabel={(option) => option.nombre || ""}
                                                    renderInput={(params) => (
                                                        <TextField {...params} variant="standard" label="Operadores" placeholder="Disponibles" />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                    <CardActions>
                                        <Button disabled={!this.state.operador} variant="contained" color={'primary'} onClick={this.agregarTagOperador}>Agregar</Button>
                                    </CardActions>
                                </Card>}
                            <br/>
                            <Grid item>
                                <Button disabled={this.state.datos.length === 0} size={'large'} variant="contained" color={'primary'} onClick={this.enviarDatosReportes}>Exportar</Button>
                            </Grid>
                        </Grid>
                        <Grid item md={6}>
                            <TagsReporte datos={this.state.datos} eliminarTag={this.eliminarTag} limpiarTag={this.limpiarTags}/>
                        </Grid>
                    </Grid>

                    <Dialog
                        open={this.state.open_importar_tag}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description">
                        <DialogTitle id="alert-dialog-title">Importar tag/s para imprimir</DialogTitle>
                        <DialogContent style={{display:'inline-grid'}}>
                                <TextField
                                    style={{width:'auto'}}
                                    type={"file"}
                                    id="file"
                                    label="Seleccione archivo"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    variant="outlined"
                                    onChange={this.handleOnFileChange}
                                />
                            {this.state.progress ? <CircularProgress style={{marginTop: '10px',justifySelf: 'center'}}/>: null}
                        </DialogContent>
                        <DialogActions>
                            <Button variant="contained" color="secondary" onClick={this.handleClose}>
                                Cancelar
                            </Button>
                            <Button disabled={!this.state.file || this.state.disabled} variant="contained" color={'primary'} onClick={this.submitForm}>
                                Subir archivo
                            </Button>
                        </DialogActions>
                    </Dialog>
                    {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
                    {this.state.open? <DialogExportar handleClose={this.handleClose} reporte={this.state.reporte}  origen={'reportes'}  params={this.state.params} refrescar={this.refrescar}/> : null}
                </div>
            )
        }
    }
}
export default Reportes;